import "./TecnoDev.css"

function TecnoDev(){
    return(
        <>
        <div className="padreInfo" >
            <div className="infoTecnoDev" id="quienesSomos">
                <h1>Sobre TecnoDev</h1>
                <h2>¿Quiénes Somos?</h2>
                <p>Somos una empresa tecnológica dedicada a la modernización del mercado. Nuestro objetivo principal es impulsar el crecimiento y la eficiencia, brindando soluciones digitales y software a medida para empresas, emprendimientos y cualquier entidad con fines lucrativos que busque escalar su potencial.</p>
            </div>
            <div className="sectorTwo">
                <div className="infoTecnoDev" id="ubicacion">
                    <h2>¿Dónde Estamos?</h2>
                    <p>Nuestras oficinas centrales se encuentran en San Miguel de Tucumán, específicamente en la calle 9 de Julio 485, 4º piso, Oficina A. Estamos listos para atenderte y comenzar a impulsar tu proyecto.</p>
                </div>
                <div className="infoTecnoDev" id="comoAyudamos">
                    <h2>Nuestro Impacto: ¿Cómo le Ayudamos a Crecer?</h2>
                    <p>El crecimiento promedio generado por nuestro trabajo ha multiplicado los ingresos de nuestros clientes por dos, e incluso por tres en casos específicos. Esto se logra no solo generando más ventas y atrayendo nuevos clientes, sino también ofreciendo paz y tranquilidad. Reemplazamos tareas de administración repetitivas con sistemas automatizados, permitiendo que usted y su equipo se enfoquen en la estrategia y el crecimiento, no en el trabajo manual.</p>
                </div>
            </div>
            
        </div>
        </>
    )
}

export default TecnoDev